import { BaseService } from './base'

export class DashboardService {
    // Get customer groups for DashboardId: 2
    static getCustomerGroups(companyId) {
        return BaseService.get(`/user/CustomerGroup?CompanyId=${companyId}`)
    }

    // Get customers by group
    static getCustomersByGroup(customerGroupId, pageNumber = 1, pageSize = 20) {
        console.log('DashboardService.getCustomersByGroup called with:', {
            customerGroupId,
            pageNumber,
            pageSize,
        })
        const url = `/Eauditor/Customer?PageNumber=${pageNumber}&PageSize=${pageSize}&customerGroupId=${customerGroupId}`
        console.log('Making API call to:', url)
        return BaseService.get(url)
    }

    // Get templates by group
    static getTemplatesByGroup(groupId, pageNumber = 1, pageSize = 20) {
        return BaseService.get(
            `/Eauditor/Group/Template?GroupId=${groupId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        )
    }
}
